import { useTranslation } from 'react-i18next'
import { LOGO_VARIANT_BASE_URL } from '../constants/apiEndpoints'
import { LogoBrandWordMarkVariantType, LogomakerLogoLayoutVariantType } from '../constants/app'

export type LogoVariationName = 'original' | 'nonLogoMaker' | LogoBrandWordMarkVariantType | LogomakerLogoLayoutVariantType
export type BackgroundMode = 'TRANSPARENT' | 'COLOR'
export type ImageType = 'PNG' | 'SVG'

export type GenerateLogoVariantUrlOptions = {
  backgroundMode: BackgroundMode
  imageType: ImageType
  logoVariation?: LogoVariationName
  width?: number
  height?: number
  makeSafeOnWhite?: boolean
}

export type GenerateLogoVariantUrl = (options: GenerateLogoVariantUrlOptions) => string

export const createLogoVariantUrlGenerator = (logoId: string, signedToken: string): GenerateLogoVariantUrl => {
  return ({ logoVariation, width, height, backgroundMode, imageType, makeSafeOnWhite }: GenerateLogoVariantUrlOptions) => {
    if (!width && !height) {
      throw new Error('Width or height must be provided')
    }

    const params = new URLSearchParams()
    params.set('sign', signedToken)

    params.set('backgroundMode', backgroundMode)
    params.set('type', imageType)

    if (logoVariation && logoVariation !== 'original') {
      params.set('logoVariation', logoVariation)
    }

    if (width) {
      params.set('width', width + '')
    }

    if (height) {
      params.set('height', height + '')
    }

    if (makeSafeOnWhite) {
      params.set('removeWhiteColor', '1')
    }

    return LOGO_VARIANT_BASE_URL + '/' + logoId + '?' + params.toString()
  }
}

export function useLogoVariantAccessibleLabel() {
  const { t } = useTranslation()
  return (variant: LogoVariationName, index: number, productName: string) => {
    const variantLabel = t(`brandkit.brandShop.accessibilityLabels.logoVariants.${variant}`)
    const labelSuffix = t('brandkit.brandShop.accessibilityLabels.logoVariantLabel')
    const willPrintOn = t('brandkit.brandShop.accessibilityLabels.willPrintOn')
    const indexText = variant === 'nonLogoMaker' ? ` ${index + 1}` : ''

    return `${variantLabel} ${labelSuffix} ${indexText} ${willPrintOn} ${productName}`
  }
}
